import { Component, Input } from '@angular/core';

type TabbedPageLayoutOptions = {
    tabListClassModifiers?: string;
};

@Component({
    selector: 'tabbed-page-layout',
    host: {
        class: 'pageWrapper greyBackground',
        '[class.pagelayout--loading]': 'options.loading'
    },
    template: `
        <div class="pageHeader pageHeader--tabbed">
            <div class="widthLimitedLayout--md">
                <h1>
                    <ng-content select="[page-header-title]"></ng-content>
                </h1>
                <p>
                    <ng-content select="[page-header-description]"></ng-content>
                </p>
            </div>
            <tab-navigator
                [listClassModifiers]="options.tabListClassModifiers"
                class="widthLimitedLayout widthLimitedLayout--md"
            >
                <ng-content select="[tab-navigator-tabs]"></ng-content>
            </tab-navigator>
        </div>
        <div class="tab-container">
            <ng-content select="[tab-navigator-pages]"></ng-content>
        </div>
    `,
    standalone: false
})
export class TabbedPageLayoutComponent {
    @Input()
    options: TabbedPageLayoutOptions = {};
}
